module.exports = __webpack_public_path__ + "static/img/30016 (3).d0a5455.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30016 (3).webp
// module id = 93/L
// module chunks = 14